
export type DeleteProjectComment403ErrorsItem = {
  /** 에러가 발생한 필드 */
  field?: string;
  /** 에러 메시지 */
  message?: string;
};
